import { render, staticRenderFns } from "./New-Forums.vue?vue&type=template&id=ccbb2c70&scoped=true&"
import script from "./New-Forums.vue?vue&type=script&lang=js&"
export * from "./New-Forums.vue?vue&type=script&lang=js&"
import style0 from "./New-Forums.vue?vue&type=style&index=0&id=ccbb2c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbb2c70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/kkid8/Documents/Kelii/Github/jarrens_stuff/Super_Grind/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VResponsive } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VImg,VLayout,VList,VListTile,VListTileAvatar,VResponsive})
